export class CycleCheckerDto {
    cycleCheckerId: number;
    unitId: number;
    physicalQuantity: number;
    itemCategoryId: number;
    itemSubCategoryId: number;
    masterBrandId: number;
    itemId: number;
    saleOrderId:number;
    createdAt: Date;
    createdUser: string;
    updatedAt: Date;
    updatedUser: string;
    versionFlag: number;
        
    constructor(cycleCheckerId: number,unitId: number,physicalQuantity: number,itemCategoryId: number,itemSubCategoryId: number,masterBrandId: number,itemId: number,saleOrderId:number,createdAt: Date,createdUser: string,updatedAt: Date,updatedUser: string,versionFlag: number){
        this.cycleCheckerId = cycleCheckerId;
        this.unitId = unitId;
        this.physicalQuantity = physicalQuantity;
        this.itemCategoryId = itemCategoryId;
        this.itemSubCategoryId = itemSubCategoryId;
        this.masterBrandId = masterBrandId;
        this.itemId = itemId;
        this.saleOrderId = saleOrderId;
        this.createdAt = createdAt;
        this.createdUser = createdUser;
        this.updatedAt = updatedAt;
        this.updatedUser = updatedUser;
        this.versionFlag = versionFlag;
    }
}